export default "__VITE_ASSET__CMMDSgh8__"